
// Components
const MatingListCard = () =>
	import(/*webpackChunkName: "mating-list-card-component" */ "@/app/views/main-view/breeding-management/mating/containers/mating-list-container/components/mating-list-card-component/mating-list-card-component.vue")


// Constants
export default {
    name: 'MatingDashboardContainer',
    components: {
        MatingListCard
    },
    directive: {},
    filters: {},
    mixins: [],
    props: {},
    data() {
        return {
            isAPILoading: false,
        }
    },
    computed: {},
    watch: {},
    created() {},
    methods: {},
    // third party libraries
}